import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/mobile-phone.png'

function MobileNode({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Mobile Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Mobile</b>
          </div>
        </div>
      </div>

      <Handle type="target" position={Position.Left} />
    </div>
  )
}

export default MobileNode
